export const FIXED_SITE_ID = 1
export const SHOW_SITE_SELECTION = false
